export default class PartyExitGameMessage {
	static protocol = {
	}

	constructor() {
	}
}
